/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import { fastagBillerService } from '@services/fastagBillerService'
import assetLoader from '@utils/internalImageLoader'
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button'
import StyledComponentsRegistry from '@configs/registry'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import { AuthLogin } from '@acko-tech/building-blocks.utils.auth-login-module'
import BankList from './bankList'
import styles from './fastagWidget.module.scss'
import styles2 from './fastagModal.module.scss'
import ShowFastagDetails from './showFastagDetails'
import GetVehicleBanner from './getVehicleBanner'
import {
  CHECK_FASTAG_TEXT,
  CROSS_ICON_TEXT,
  FILTER_BANK,
  ICONS,
  SELECT_FASTAG_PROVIDER,
  SEARCH_BANK_INPUT_PLACEHOLDER,
  SEARCH_RESULT_TEXT,
  ALL_FASTAG_PROVIDER,
  AUTH_FASTAG_CLIENT,
} from './constants'
import FindFastagProvider from './findFastagProvider'

const FastagModal = ({
  setShow,
  setShowModal,
  regNo,
  autoData,
  segmentEventCommonProperties,
  keyFeatures,
  showLoginModal,
  setIsModalOpen,
  isModalOpen,
  verifyOtpSuccess,
  callR2d2,
  isLoggedIn,
  setShowLoginModal,
  showFastagDetails,
  setShowFastagDetails,
  phone,
  fastagData,
  setFastagData,
}) => {
  useEffect(() => {
    const fetchData = async () => {
      const data = await fastagBillerService(setIsFetchingProvider)
      setFastagProvider(data)
    }
    fetchData()
  }, [])

  const [noFastagFound, setNoFastagFound] = useState<boolean>(false)
  const [isInputFocused, setIsInputFocused] = useState<boolean>(false)

  const [selectedBank, setSelectedBank] = useState(null)
  const [searchBank, setSearchBank] = useState<string>('')
  const [showFastagProviderImg, setShowFastagProviderImg] = useState<boolean>(false)
  const [fastagProvider, setFastagProvider] = useState<any>([])
  const [isFetchingProvider, setIsFetchingProvider] = useState<boolean>(true)
  // Filtered banks based on search input
  const filteredBanks = FILTER_BANK(fastagProvider, searchBank)

  // ref
  const inputRef = useRef<any>(null)

  const handleClick = bankName => {
    setSelectedBank(bankName) // Set the clicked bank as selected
  }
  const initializeLoginSdk = () => {
    // eslint-disable-next-line no-new
    new AuthLogin({
      clientId: AUTH_FASTAG_CLIENT,
      onSuccess: () => {
        verifyOtpSuccess()
      },
      onClose: () => onLoginClose(),
      enableScrollOnClose: true
    })
  }

  const handleBtnClick = () => {
    if (!isLoggedIn) {
      setShowLoginModal(true)
      setIsModalOpen(true)
      initializeLoginSdk()
    }
    if (isLoggedIn && selectedBank) setShowFastagDetails(true)
  }

  const onBankSearch = e => {
    setSearchBank(e.target.value)
  }

  const onModalClose = () => {
    setShowModal(false)
    setShow(false)
    setSelectedBank(null)
  }

  const onLoginClose = () => {
    setShowModal(false)
    setShow(false)
    setSelectedBank(null)
    setShowLoginModal(false)
  }

  return (
    <div className={`${styles.fastagModal} ${showLoginModal ? styles.fastagModalLogin : ''} `}>
      <div className={styles2.fastagModalWrapper}>
        {!showFastagDetails ? (
          <div>
            <div className={styles2.fastagModalContainer}>
              <div className={styles2.fastagModalHeader}>
                <p>{CHECK_FASTAG_TEXT}</p>
                <span onClick={onModalClose}>
                  <Image src={`${assetLoader()}${ICONS.close}`} alt={CROSS_ICON_TEXT} width={20} height={20} />
                </span>
              </div>
              <GetVehicleBanner autoData={autoData} regNo={regNo} />
              <div className={styles2.fastagInputSearch}>
                <h2 className={styles2.fastagInputSearchText}>{SELECT_FASTAG_PROVIDER}</h2>
                <div className={styles2.fastagInputContainer}>
                  <div className={styles2.fastagInputSearchImg}>
                    <PropertyControlledComponent
                      fallback={<Image src={`${assetLoader()}${ICONS.search}`} alt="search" width={20} height={20} />}
                      controllerProperty={isInputFocused}>
                      <Image
                        src={`${assetLoader()}/images/arrow-down-grey.svg`}
                        className={styles2.inputArrow}
                        alt="search"
                        width={15}
                        height={15}
                      />
                    </PropertyControlledComponent>
                  </div>
                  <input
                    type="text"
                    value={searchBank}
                    className={`${isInputFocused ? styles2.inputOnFocus : ''}`}
                    onChange={e => onBankSearch(e)}
                    placeholder={SEARCH_BANK_INPUT_PLACEHOLDER}
                    ref={inputRef}
                    onFocus={() => setIsInputFocused(true)}
                    onBlur={() => setIsInputFocused(false)}
                  />
                  <PropertyControlledComponent fallback={null} controllerProperty={searchBank}>
                    <div
                      className={styles2.fastagInputCross}
                      onClick={() => {
                        setSearchBank('')
                        setIsInputFocused(true)
                        inputRef.current.focus()
                      }}>
                      <Image src={`${assetLoader()}${ICONS.close}`} alt="search" width={20} height={20} />
                    </div>
                  </PropertyControlledComponent>
                </div>
              </div>
              <div className={styles2.fastagList}>
                <span>{searchBank ? SEARCH_RESULT_TEXT : ALL_FASTAG_PROVIDER}</span>
                <div className={styles2.fastagListWrapper}>
                  <BankList
                    isFetchingProvider={isFetchingProvider}
                    filteredBanks={filteredBanks}
                    handleClick={handleClick}
                    selectedBank={selectedBank}
                  />
                </div>
              </div>
            </div>
            <div className={styles2.continueBtnWrapper}>
              <StyledComponentsRegistry>
                <PrimaryButton
                  type="submit"
                  onClick={() => handleBtnClick()}
                  className={styles2.continueBtn}
                  disabled={!selectedBank}>
                  Continue
                </PrimaryButton>
              </StyledComponentsRegistry>
            </div>
            <FindFastagProvider
              setShowFastagProviderImg={setShowFastagProviderImg}
              showFastagProviderImg={showFastagProviderImg}
            />
          </div>
        ) : (
          <>
            <ShowFastagDetails
              regNo={regNo}
              keyFeatures={keyFeatures}
              segmentEventCommonProperties={segmentEventCommonProperties}
              selectedBank={selectedBank}
              setSelectedBank={setSelectedBank}
              setShowFastagDetails={setShowFastagDetails}
              autoData={autoData}
              onModalClose={onModalClose}
              noFastagFound={noFastagFound}
              setNoFastagFound={setNoFastagFound}
              phone={phone}
              fastagData={fastagData}
              setFastagData={setFastagData}
            />
            <PropertyControlledComponent fallback={null} controllerProperty={noFastagFound}>
              <FindFastagProvider
                setShowFastagProviderImg={setShowFastagProviderImg}
                showFastagProviderImg={showFastagProviderImg}
              />
            </PropertyControlledComponent>
          </>
        )}
      </div>
    </div>
  )
}

export default FastagModal
